import { HilSignal } from '@cadstrom/backend/shared';

import { SignalChip } from '#components/signal-chip/signal-chip.js';
import { useSignalReferenceContext } from './signal-reference-context.js';

export interface SignalMarkdownItemProps {
	signalName?: string;
}

/**
 * Renders a markdown signal reference as the standard attribute-coloured signal chip.
 * The name resolves against the signals from the surrounding signal reference context;
 * an unresolved name (or no provider at all) keeps a plain chip in the same visual family,
 * with attributes and tooltip suppressed because a bare name can produce neither.
 */
export function SignalMarkdownItem(props: SignalMarkdownItemProps) {
	const signalContext = useSignalReferenceContext(false);

	if (props.signalName === undefined) {
		return null;
	}

	const signal = signalContext?.signalsByName.get(props.signalName);

	return (
		<span className='isolate mx-0.5 inline-flex items-center align-middle'>
			{signal === undefined ?
				<SignalChip
					signal={HilSignal.create({ name: props.signalName })}
					allSignals={[]}
					compact
					appearance='dots'
					showAttributes={false}
					disableTooltip
				/>
			:	<SignalChip signal={signal} allSignals={signalContext?.allSignals ?? []} compact appearance='dots' />}
		</span>
	);
}
